import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=12a72852&scoped=true"
import script from "@/views/Groups/Group.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Group.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/group.scss?vue&type=style&index=0&id=12a72852&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a72852",
  null
  
)

export default component.exports